import { useMutation, useQueryClient } from "@tanstack/react-query";
import useSelectedStores from "@lib/hooks/use-selected-stores";
import type { Dashboard } from "@lib/types/dashboards";
import {
  createDashboardWithAddedInsights,
  invalidateDashboardQueries,
  updateDashboardOnServer,
} from "./utils";

type AddInsightToDashboardInput =
  | {
      dashboard: Dashboard;
      insightId: string;
    }
  | {
      dashboard: Dashboard;
      insightIds: string[];
    };

export function useAddInsightToDashboard() {
  const queryClient = useQueryClient();
  const { selectedOrganisation } = useSelectedStores();

  return useMutation({
    mutationFn: async (input: AddInsightToDashboardInput) => {
      if (!selectedOrganisation) {
        throw new Error("Organisation ID is required");
      }

      const insightIds =
        "insightIds" in input ? input.insightIds : [input.insightId];

      return updateDashboardOnServer(
        selectedOrganisation,
        input.dashboard.id,
        createDashboardWithAddedInsights(input.dashboard, insightIds)
      );
    },
    onSuccess: async (updatedDashboard) => {
      await invalidateDashboardQueries(
        queryClient,
        selectedOrganisation,
        updatedDashboard.id
      );
    },
  });
}
